export const getIsPublishAvailable = (
  isErpStatusDeleted: boolean,
  isErpStatusDisapproved: boolean,
  isErpStatusSyspApprove: boolean,
  isErpStatusNeedDoOverAgain: boolean,
) => !isErpStatusDeleted && !isErpStatusDisapproved && !isErpStatusSyspApprove && !isErpStatusNeedDoOverAgain;
